module.exports = "/_next/static/images/sedan-cf4b7e8c70c4f113415d302dfdabb950.jpg";